<template>
    <div class="content">
      <el-tabs class="tabLv3" type="border-card" v-model="tabName"><i class="lt"></i><i class="rt"></i>
        <el-tab-pane name="xjrwgl">
          <span slot="label"><i class="iconfont iconcheck"></i><i class="border"></i> 一键查岗 </span>
          <!-- <normalNav :parent="self">
            <button class="GreenSmBtn download" @click="editDialogVisible=true">新增</button>
          </normalNav> -->
          <div class="searchForm1">
             <!-- <searchForm
                :items="items"
                :formPlus="form_xjrwgl"
                ref="searchForm_xjrwgl"
              >
              </searchForm> -->
          </div>
          <div class="tableWrapper">
            <section class="easyTable">
            <el-table
              :data="tabledata.list"
              class="stripeTable"
              stripe
              style="width: 100%"
              ref="table_jsgl"
            >
            <el-table-column
              show-overflow-tooltip
              v-for="{ prop, label } in config"
              :key="prop.toString()"
              :label="label"
              :prop="prop"
              :render-header="labelHead"
            >
            </el-table-column>
            <el-table-column
              :formatter="checkMatter"
              show-overflow-tooltip
              label="查岗状态"
              prop="state"
            >
            </el-table-column>
              <el-table-column label="操作" align="center" width="400">
                <template slot-scope="scope">
                  <el-button
                    v-if="scope.row.state===0"
                    type="text"
                    size="small"
                    @click="check(scope.row)"
                  >查岗</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div class="footer">
              <el-pagination
                layout="prev, pager, next"
                :total="tabledata.total"
              ></el-pagination>
            </div>
          </section>
          </div>
    
          <!-- <el-dialog class="editDialog" title="资产录入" :visible.sync="editDialogVisible" :close-on-click-modal="false">
            <section class="list">
              <el-form ref="form1" :model="form1" :rules="rule" label-position="right">
    
                <el-form-item label="资产名称" prop="assetName">
                  <el-input class="darkSelect" v-model="form1.assetName" placeholder="请输入资产名称"></el-input>
                </el-form-item>
    
                <el-form-item label="资产编码">
                  <el-input  v-model="form1.assetCode" placeholder="请输入资产编码"></el-input>
                </el-form-item>
    
                <el-form-item label="资产类型" prop="assetType">
                  <el-select v-model="form1.assetType" placeholder="请选择资产类型">
                  <el-option :label="item.label" :value="item.value" v-for="(item,index) in assetTypeArr" :key="index"></el-option>
                </el-select>
                </el-form-item>
    
                <el-form-item label="资产说明">
                  <el-input class="darkSelect" v-model="form1.assetDesc" placeholder="请输入资产说明"></el-input>
                </el-form-item>
                <el-form-item label="附件上传">
                  <el-upload-secondary class="YnormalCard" v-model="form1.assetPic" :limit="3" accepts="docx,pdf,png,jpg">
                    <i class="el-icon-plus"></i>
                  </el-upload-secondary>
                  <div class="el-form-item__error" v-show="!form1.assetPic||form1.assetPic.length==0" slot="error">
                    请上传附件
                  </div>
                </el-form-item>
    
              </el-form>
            </section>
    
            <div slot="footer" class="dialog-footer">
              <el-button class="confirmButton" type="primary" @click="sumbit">提交</el-button>
              <el-button class="cancelButton" type="primary" @click="editDialogVisible = false">取消</el-button>
            </div>
          </el-dialog> -->
    
          <!-- <el-dialog class="editDialog" title="详情" :visible.sync="detailsVisible" :close-on-click-modal="false">
            <section class="list">
              <el-form ref="detailsList" :model="detailsList" :rules="rule" label-position="right">
    
                <el-form-item label="资产名称" prop="assetName">
                  <el-input class="darkSelect" v-model="detailsList.assetName" :disabled="disabled"></el-input>
                </el-form-item>
    
                <el-form-item label="资产编码">
                  <el-input  v-model="detailsList.assetCode" :disabled="disabled"></el-input>
                </el-form-item>
    
                <el-form-item label="资产类型" prop="assetType">
                  <el-select v-model="detailsList.assetType" placeholder="请选择资产类型" :disabled="disabled">
                  <el-option :label="item.label" :value="Number(item.value)" v-for="(item,index) in assetTypeArr" :key="index"></el-option>
                </el-select>
                </el-form-item>
    
                <el-form-item label="资产说明">
                  <el-input class="darkSelect" v-model="detailsList.assetDesc" :disabled="disabled"></el-input>
                </el-form-item>
                <el-form-item label="图片显示">
                  <img v-default-img v-for="(i,index) in detailsList.assetPic" :key="index" :src="i" alt="加载中" />
                  <el-upload-secondary class="YnormalCard" v-model="xgPicList" :limit="3" accepts="docx,pdf,png,jpg" v-if="!disabled">
                    <i class="el-icon-plus"></i>
                  </el-upload-secondary>
                  <div class="el-form-item__error" v-show="!xgPicList||xgPicList.length==0" slot="error">
                    请上传附件
                  </div>
                </el-form-item>
    
              </el-form>
            </section>
            <div slot="footer" class="dialog-footer">
              <el-button class="confirmButton" type="primary" @click="xiugai" v-if="!disabled">提交</el-button>
              <el-button class="cancelButton" type="primary" @click="detailsVisible = false">返回</el-button>
            </div>
          </el-dialog> -->
        </el-tab-pane>
      </el-tabs>
    </div>
    </template>
    
    <script>
    export default {
      data() {
        return {
          tabName: 'xjrwgl',
          tzs: [],
          assetTypeArr:[],
          form_xjrwgl: {},
          editLoading: true,
          editDialogVisible: false,
          detailsVisible:false,
          detailsList:[],
          xgPicList:[],
          data: {},
          other: {},
          form1: {},
          assetTypeList:[],
          disabled:true,
          tabledata: {
            list:[{name:'岗位一',state:0},{name:'岗位二',state:1},{name:'岗位三',state:0},{name:'岗位一',state:0}],
            total:4
          },
        };
      },
      watch:{
        editDialogVisible(){
          this.$refs['form1'].resetFields();
        },
        detailsVisible(){
          this.xgPicList=[]
        }
      },
      computed: {
        items() {
          const that = this;
          return [{
              type: "input",
              prop: "assetName",
              label: "资产名称",
              placeholder: "请输入资产名称",
            },
            {
              type: "select",
              prop: "assetType",
              label: "资产类型",
              placeholder: "请输入资产类型",
              option: {
                option: that.tzs,
              }
            },
            {
              type: "select",
              prop: "assetState",
              label: "资产状态",
              placeholder: "请输入资产状态",
              option: {
                option: [{label:'闲置',value:1},{label:'占用',value:2},{label:'注销',value:3}],
              }
            },
          ]
        },
        self() {
          return this;
        },
        config() {
          return [{
            prop: 'name',
            label: '岗位名称'
          }];
        },
        rule() {
          let that = this;
          return {
            assetType: descriptor(new Map([
              [true, "请输入资产类型"]
            ]), "blur"),
            assetName: descriptor(new Map([
              [true, "请输入资产名称"]
            ]), "blur"),
          }
        }
      },
      methods: {
        check(row){
            this.$confirm('此操作将改变在岗状态, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                row.state=1
                this.$message({
                type: 'success',
                message: '查岗成功!'
            }); 
            })
        },
        checkMatter(row, column) {
            if(row.state === 0) {
                return "待查岗"
            } else {
                return "在岗"
            }
        },
        reset_xjrwgl(fn) {
          fn();
          this.form_xjrwgl = {};
        },
        search_xjrwgl(fn) {
          fn();
        },
        sumbit() {
          this.$refs["form1"].validate((valid) => {
          if (valid) {
            let arr=[]
            let object
            if(this.form1.assetPic){
              // this.form1.assetPic.forEach((i)=>arr.push( i.response.data[0] ))
              this.form1.assetPic.forEach((i) => arr.push( i.response.data[0].startsWith('http') ? i.response.data[0] : (process.env.fileUrl + "/" + i.response.data[0])))
              object={...this.form1,assetPic:arr.join()}
            }else{
              object={...this.form1}
            }
            this.$axiospost('extra/asset', object).then(res => {
              if (res.data.status === "10000" || res.data.status === 10000) {
                this.$message.success("提交成功！");
              }
              this.editLoading = false;
              this.editDialogVisible = false;
              this.$refs["table_xjrwgl"].getData();
            })
          }})
        },
        xiugai(){
          this.$refs["detailsList"].validate((valid) => {
            if (valid) {
              let object
              if(this.detailsList.assetPic){
                object={...this.detailsList,assetPic:this.detailsList.assetPic.join()}
              }else{
                object={...this.detailsList}
              }
              if(this.xgPicList){
                let arr=[]
                // this.xgPicList.forEach((i)=>arr.push(i.response.data[0]))
                this.xgPicList.forEach((i)=>arr.push(i.response.data[0].startsWith('http') ? i.response.data[0] : (process.env.fileUrl + "/" + i.response.data[0])))
                object.assetPic=arr.join()
              }
              this.$axiosput('extra/asset', object).then(res => {
                if (res.data.status === "10000" || res.data.status === 10000) {
                  this.$message.success("修改成功！");
                }
                this.editLoading = false;
                this.detailsVisible = false;
                this.$refs["table_xjrwgl"].getData();
              })
            }
          })
        },
        details(scope,disabled){
          this.detailsList={...scope}
          this.detailsList.assetPic?this.detailsList.assetPic=this.detailsList.assetPic.split(','):this.detailsList.assetPic
          this.detailsVisible=true
          this.disabled=disabled
        },
        handleClick(scope,type){
          //2归还，1领用
          if(type===1){
            this.$confirm('此操作将领用资产, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
    
            this.$axiospost(`extra/activiti/asset/apply?assetId=${scope.id}`).then(res => {
              if (res.data.status === "10000" || res.data.status === 10000) {
              this.$message({
                type: 'success',
                message: '领用成功!'
              });
            }
              this.$refs["table_xjrwgl"].getData();
            })
    
            }).catch(() => {
              this.$message({
                type: 'info',
                message: '已取消领用'
              });
            });
          }
        },
        cancellation(scope){
          this.$axiosput(`extra/asset/status`,{assetState:3,id:scope.id
          }).then(res => {
            this.$refs["table_xjrwgl"].getData();
          })
        },
        buling(num, length) {
          for(var len = (num + "").length; len < length; len = num.length) {
          num = "0" + num;
          }
          return num;
        }
      },
      components: {
        normalNav: () => import("public/normalNav"),
        searchForm: () => import("public/searchForm"),
        easyTable: () => import("public/easyTable"),
        nextCompany: () => import("public/nextCompany")
      },
      mounted() {
      }
    };
    </script>
    
    <style lang="less" scoped>
    .point {
      span {
        padding-left: 5px;
        color: #FFF;
        font-size: 14px;
        display: inline-block;
        height: 14px;
        line-height: 14px;
        border-left: 2px solid #35b9f7;
      }
    
      border-bottom:1px solid #777;
      line-height: 36px;
      margin-top: 15px;
      margin-bottom: 15px;
    }
    /deep/ .editDialog .el-form-item__label{
      text-align: right!important;
    }
    .el-dropdown-link {
        cursor: pointer;
        color: #409EFF;
        margin-left: 10px;
        font-size: 10px;
    }
    .el-form-item__content {
      img{
      max-width: 400px;
      max-height: 400px;
      }
    }
    </style>
    


// WEBPACK FOOTER //
// src/components/dynamicRoute3/management/checkThePosition/checkThePosition.vue